import React from 'react'
import { ConfigurationSignatureHistoryDetailView } from '../../views'
import { SignatureRequestService, SignerService, LocalStorageService } from '../../../services/index'

class ConfigurationSignatureHistoryDetailAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      signatureRequest: {},
      signRequestPDF: '',
      expirationDate: '',
      comments: '',
      signRequest: {},
      userCanSign: '',
      signStatusName: '',
      signStatusColor: '',
      isSignRequestPending: false,
      isSignRequestReject: false,
      userCanEditExpirationDate: false,
      limitExpirationDate: '',
      routeIsFromIndex: false,

      dataItem: {},
      newSign: '',

      visibleAccept: false,
      visibleReject: false,
      visibleExpirationDate: false,

      // subtitle: 'Información de la solicitud de Firma',
      userHasPfx: false,
      userPfx: '',
      userRequestingSign: '',
      signRequestSigners: [],

      showNotification: false,
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,

      skip: 0,
      take: 6,
      date: new Date(),
    }
  }

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  signatureRequestService = new SignatureRequestService(this.url)
  signerService = new SignerService(this.url)
  localStorageService = new LocalStorageService()

  async componentDidMount() {
    this.setState({ loading: true })
    let requestId = this.props.match.params.id
    this.token = this.localStorageService.getLocalStorageItem('token').idToken

    let signatureRequest = await this.signatureRequestService.getSignatureRequestById(requestId, this.token)
    let userRequesting = `${signatureRequest.userRequestingSing.firstName} ${signatureRequest.userRequestingSing.firstLastName} ${signatureRequest.userRequestingSing.secondLastName}`
    this.setState({
      signatureRequest,
      signRequest: signatureRequest.signRequest,
      signRequestId: requestId,
      userRequestingSign: userRequesting,
      signRequestSigners: signatureRequest.signersList
    })

    let signStatusName = signatureRequest.signRequest.signRequestStatus.name
    this.setState({ signStatusName })
    if (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)) { // pendings
      this.setState({ signStatusColor: 'status-pending', isSignRequestPending: true })
    } else if (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)) { // rejects
      this.setState({ signStatusColor: 'status-reject', isSignRequestReject: true })
    } else if (signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET)) { // completes
      this.setState({ signStatusColor: 'status-complete' })
    }

    this.setState({ loading: false })

    if (this.props.match.params) {
      if (this.props.match.params.route === 'index') {
        this.setState({ routeIsFromIndex: true })
      }
    }
  }

  /**
   * @author  Lucia Alvarado
   * @description Method to move scroll
   * @memberof ConfigurationSignatureHistoryDetailAction
  */
  scrollWindow = () => {
    window.scrollTo(0, 0)
  }
  
  render() {
    return (
      <ConfigurationSignatureHistoryDetailView
        {...this.state}
        view={this.props.match.params}
        scrollWindow={this.scrollWindow}
      />
    )
  }
}


export { ConfigurationSignatureHistoryDetailAction as default }